import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import Default from 'react-bootstrap/Card';
import { Media } from '../media/media.esm.js';
import { Body } from '../text/body/body.esm.js';
import { Description } from '../text/description/description.esm.js';
import { Title } from '../text/title/title.esm.js';
import { TabIndicator } from './components/tab-indicator.esm.js';

const _Card = ({ children, className, accentBar, cornerSize = 'md', style, ...rest }, ref)=>jsxs(Default, {
        /**
     * Surpresses the hydration warning when using the card component in the carousel
     * as we do not know the users breakpoint when the component is rendered on the server.
     */ suppressHydrationWarning: true,
        className: classNames({
            'card-accent-bar': accentBar,
            'card-corner-size-large': cornerSize === 'lg'
        }, className),
        ref: ref,
        style: style,
        ...rest,
        children: [
            accentBar && jsx("div", {
                className: "accent-bar"
            }),
            children
        ]
    });
const customComponents = {
    /**
     * Custom components
     */ Subtitle: Description,
    Text: Body,
    Title,
    Media: ({ aspectRatio, objectFit, ...rest })=>jsx(Media, {
            hideBorder: true,
            aspectRatio: aspectRatio,
            objectFit: objectFit || 'cover',
            ...rest
        }),
    TabIndicator
};
const defaultComponents = {
    /**
     * Default react-bootstrap components
     */ Img: Default.Img,
    Body: Default.Body,
    Link: Default.Link,
    Header: Default.Header,
    Footer: Default.Footer,
    ImgOverlay: Default.ImgOverlay
};
const _CardWithRef = /*#__PURE__*/ forwardRef(_Card);
const Card = Object.assign(_CardWithRef, customComponents, defaultComponents);

export { Card };
